import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import Text from '../shared/Text';
import Image from '../shared/Image';
import Portal from '../shared/Portal';

import { IS_WEB } from '../../lib/appConstants';
import { GOLDEN200, pOrT, WINDOW_WIDTH, WINDOW_HEIGHT } from '../styleConstants';

const MENU_ICON_SIZE = pOrT(18, 24);

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  menu: {
    position: 'absolute',
    backgroundColor: '#1a0f08',
    borderWidth: 1,
    borderColor: '#8f6b50',
    borderRadius: 4,
    minWidth: pOrT(120, 160),
    zIndex: 999,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: pOrT(6, 10),
    paddingHorizontal: pOrT(10, 14),
  },
  itemBorder: {
    borderBottomWidth: 1,
    borderBottomColor: '#8f6b50',
  },
  itemText: {
    color: GOLDEN200,
    fontSize: pOrT(13, 17),
    marginLeft: pOrT(8, 10),
  },
  icon: {
    width: MENU_ICON_SIZE,
    height: MENU_ICON_SIZE,
  },
});

const MenuItems = ({ items, onClose }: { items: any[]; onClose: () => void }) => (
  <>
    {items.map((item: any, index: number) => (
      <TouchableOpacity
        key={item.key}
        style={[styles.item, index < items.length - 1 ? styles.itemBorder : null]}
        onPress={() => {
          onClose();
          setTimeout(() => item.onPress(), 300);
        }}
      >
        <Image style={styles.icon} resizeMode="contain" source={item.source} />
        <Text bold style={styles.itemText}>
          {item.label}
        </Text>
      </TouchableOpacity>
    ))}
  </>
);

const MenuContent = ({
  items,
  onClose,
  menuStyle,
}: {
  items: any[];
  onClose: () => void;
  menuStyle?: any;
}) => (
  <View style={{ position: 'fixed' as any, top: 0, left: 0, right: 0, bottom: 0, zIndex: 998 }}>
    <TouchableOpacity
      style={[StyleSheet.absoluteFill, styles.overlay]}
      onPress={onClose}
      activeOpacity={1}
    />
    <View style={[styles.menu, menuStyle]}>
      <MenuItems items={items} onClose={onClose} />
    </View>
  </View>
);

const HeaderMenu = ({
  items,
  onClose,
  menuStyle,
}: {
  items: any[];
  onClose: () => void;
  menuStyle?: any;
}) =>
  IS_WEB ? (
    <Portal>
      <MenuContent items={items} onClose={onClose} menuStyle={menuStyle} />
    </Portal>
  ) : (
    <View style={{ zIndex: 998 }}>
      <TouchableOpacity
        style={{
          position: 'absolute',
          top: -WINDOW_HEIGHT,
          left: -WINDOW_WIDTH,
          width: WINDOW_WIDTH * 3,
          height: WINDOW_HEIGHT * 3,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
        onPress={onClose}
        activeOpacity={1}
      />
      <View style={[styles.menu, menuStyle]}>
        <MenuItems items={items} onClose={onClose} />
      </View>
    </View>
  );

export default HeaderMenu;
